import React from 'react';
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import StarIcon from '@mui/icons-material/Star';
import AvatarComponent from "./avatarComponent";
import Button from "@mui/material/Button";

function AvisComponent() {
    return (
        <div className="section avis-content">

            <Container maxWidth="md" >
                <h1>Ils m'ont fait confiance</h1>

                <Grid container spacing={1}>
                    <Grid item xs={6} sm={3}>
                        <div className="avis-title">
                            <AvatarComponent name={"Ophélie Moutte"} image={""} />
                            <div>
                                <span className="avis-name">Ophélie Moutte</span>
                                <div className="stars">
                                    <StarIcon />
                                    <StarIcon />
                                    <StarIcon />
                                    <StarIcon />
                                    <StarIcon />
                                </div>
                            </div>
                        </div>
                        <p className="avis-text">Les créations de Myriam sont originales, personnalisables, fait main et avec beaucoup d'amour. On ressent qu'elle est passionnée par le travail de qualité qu'elle fournit.
                            Je recommande vivement.👏👍
                        </p>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <div className="avis-title">
                            <AvatarComponent name={"Emilia Araujo Ribeiro"} image={""} />
                            <div>
                                <span className="avis-name">Emilia Araujo Ribeiro</span>
                                <div className="stars">
                                    <StarIcon />
                                    <StarIcon />
                                    <StarIcon />
                                    <StarIcon />
                                    <StarIcon />
                                </div>
                            </div>
                        </div>
                        <p className="avis-text">Super idée de cadeau, très original avec pleins de petits objets utiles ! J'ai adoré pour mes petits enfants Liam et Mylan 👶🏻 👍</p>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <div className="avis-title">
                            <AvatarComponent name={"Isab Thr"} image={""} />
                            <div>
                                <span className="avis-name">Isab Thr</span>
                                <div className="stars">
                                    <StarIcon />
                                    <StarIcon />
                                    <StarIcon />
                                    <StarIcon />
                                    <StarIcon />
                                </div>
                            </div>
                        </div>
                        <p className="avis-text">achat pour cadeau naissance original bien emballé et super beau merci beaucoup !☺</p>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <div className="avis-title">
                            <AvatarComponent name={"Adeline Detis"} image={""} />
                            <div>
                                <span className="avis-name">Adeline Detis</span>
                                <div className="stars">
                                    <StarIcon />
                                    <StarIcon />
                                    <StarIcon />
                                    <StarIcon />
                                    <StarIcon />
                                </div>
                            </div>
                        </div>
                        <p className="avis-text">Très belle présentation, cadeau original et pratique. Sans hésitation,  je ferai appel à vos petites mains lorsque j'aurai à mon tour un cadeau de naissance à faire.</p>
                    </Grid>
                </Grid>

                <div className="section-buttons">
                    <Button size="large" variant="contained" href="https://www.facebook.com/TendreConception/reviews" target="_blank">Voir plus</Button>
                </div>

            </Container>
        </div>
    )
}

export default AvisComponent;